import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PublicFooter, KIND_PATH, usePublishedPages, pageLabel, pagePath } from "@/components/PublicFooter";
import { usePageSeo } from "@/components/Seo";

const META = {
  city: { title: "Feasibility Studies by Location", h1: "Feasibility studies near you", text: "Local market, site and financial analysis for projects in cities across the United States." },
  industry: { title: "Feasibility Studies by Industry", h1: "Feasibility studies by industry", text: "See what a study covers for your type of business, with sample sections, costs and risks." },
  article: { title: "Feasibility Study Guides & Resources", h1: "Guides and resources", text: "Practical guides for business owners and borrowers preparing a feasibility study." },
};

export default function SiteIndex({ kind }) {
  const m = META[kind];
  const pages = usePublishedPages().filter((p) => p.kind === kind);
  usePageSeo({ title: m.title, description: m.text, path: KIND_PATH[kind] });
  return (
    <div data-testid={`site-index-${kind}`} className="public-site">
      <section className="border-b border-slate-800/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-14 fade-up">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-400 mb-5">{m.title}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mb-6 text-slate-50">{m.h1}</h1>
          <p className="text-slate-300 text-base md:text-lg max-w-2xl">{m.text}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-2 gap-x-12">
        {pages.map((p) => (
          <Link key={p.id} to={pagePath(p)} data-testid={`site-index-card-${p.slug}`}
            className="group py-6 border-t border-slate-800 flex gap-6 items-start">
            <div className="flex-1 min-w-0">
              <p className="text-lg font-semibold mb-1.5 text-slate-100 group-hover:text-emerald-300 transition-colors">{kind === "article" ? p.title : pageLabel(p)}</p>
              <p className="text-sm text-slate-400 line-clamp-2">{p.meta_description || p.intro}</p>
            </div>
            <ArrowRight className="h-4 w-4 mt-1.5 shrink-0 text-slate-600 transition-[transform,color] group-hover:translate-x-1 group-hover:text-slate-300" />
          </Link>
        ))}
        {!pages.length && <p className="text-slate-500" data-testid="site-index-empty">Nothing published here yet.</p>}
      </section>
      <PublicFooter />
    </div>
  );
}
